export default __webpack_public_path__ + "static/main5-eab13fc32b3e4746d4adfba9841378c0.png";